

import { useId } from 'react';
import { NavLink } from 'react-router-dom';

const o_feature_paths = {
    1: [
        'M25 24c-2-9 3-15 14-16 1 11-4 17-14 16Z',
        'm24 27 10-13M24 21C17 22 12 18 12 11c8 0 12 3 12 10Zm-7-5 7 7',
        'M7 31h7v12H7zM14 33h8c3 0 5 2 5 4h-9',
        'm27 37 10-6c4-2 7 2 4 5L26 43H14',
    ],
    2: [
        'M24 35C14 28 15 19 24 11c9 8 10 17 0 24Z',
        'M24 35C12 36 6 28 7 18c7 0 13 4 17 11',
        'M24 35c12 1 18-7 17-17-7 0-13 4-17 11',
        'M14 41h20M24 4v2M9 8l3 3M39 8l-3 3',
    ],
    3: [
        'M10 13h20a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V16a3 3 0 0 1 3-3Z',
        'm33 20 9-6v20l-9-6M13 19h7',
    ],
    4: [
        'm6 39 18-29 18 29H6ZM20 5l4 5 4-5',
        'm16 39 8-15 8 15M24 24v15M3 43h42',
    ],
    5: [
        'M25 24 15 14C8 7 19 0 25 9c6-9 17-2 10 5L25 24Z',
        'M6 31h7v12H6zM13 33h9c3 0 5 2 5 4h-9',
        'm27 37 10-6c4-2 7 2 4 5L26 43H13',
    ],
    6: [
        'M41 24a17 17 0 1 1-34 0 17 17 0 0 1 34 0Z',
        'M24 7c10 9 10 25 0 34-10-9-10-25 0-34Z',
        'M8 18h32M8 30h32',
    ],
};

const WhatWeDo = (props) => {
    const o_title_id = useId();

    return (
        <>
            <NavLink to={props.Link} className={`yk-discover-card${props.i_feature_id === 1 ? ' yk-discover-card--featured' : ''}`} aria-labelledby={o_title_id}>
                <div className="yk-discover-card-top" aria-hidden="true">
                    <span className="yk-discover-icon">
                        <svg viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false">
                            {(o_feature_paths[props.i_feature_id] || o_feature_paths[1]).map((i_path) => (
                                <path key={i_path} d={i_path} vectorEffect="non-scaling-stroke" />
                            ))}
                        </svg>
                    </span>
                    <span className="yk-discover-number">{String(props.i_position).padStart(2, '0')}</span>
                </div>
                <h3 id={o_title_id} className="yk-discover-title">{props.title}</h3>
                <p className="yk-discover-description">{props.Desc}</p>
                <span className="yk-discover-action">
                    <span>{props.Readtext}</span>
                    <span className="yk-discover-arrow" aria-hidden="true">
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                    </span>
                </span>
            </NavLink>


            {/* <!--Service Block--> */}

            {/* <div className="service-block col-lg-4 col-md-6 col-sm-12 wow fadeInLeft animated" data-wow-delay="0ms" >
                        <div className="inner-box">
                            <div className="icon"><span className="flaticon-therapy"></span></div>
                            <h3><a href="words-of-wisdom.html">Words of Wisdom</a></h3>
                            <div className="text">
                                Words of Wisdom is inspirational message sent out by Didi Ji every Friday. To receive weekly emails of Words of Wisdom

                            </div>
                            <div className="link-box"><a href="words-of-wisdom.html" className="theme-btn">Read More</a></div>
                        </div>
                    </div> */}

        </>

    )

}

export default WhatWeDo;